function moduleAccordion() {
	/** @type {NodeListOf<HTMLDetailsElement>} */
	const detailsElements = document.querySelectorAll('.module.accordion.scroll-animation details');
	for (const details of detailsElements) {
		const content = details.nextElementSibling;
		const transitionDuration = parseFloat(window.getComputedStyle(content).transitionDuration ?? 0) * 1000;

		/** @type{number|null} */
		let timeoutId = null;
		details.addEventListener('toggle', () => {
			// Cancel setTimeout if interrupted
			if (typeof timeoutId === 'number') {
				clearTimeout(timeoutId);
			}

			if (details.open) {
				timeoutId = setTimeout(() => {
					details.scrollIntoView({ behavior: 'smooth' });
				}, transitionDuration);
			}
		});
	}
}
